<template>
	<div v-if="items.length" class="card-v2 card-jobs-inactive-queue">
		<header class="margin">
			<h2>Jobs without Active Queues</h2>
		</header>

		<div class="grid gap-16">
			<ItemJobInactiveQueue v-for="(job, i) in items" :job="job" :key="i" />
		</div>
	</div>	
</template>

<script>
import { request } from '@/plugins/axios';
import ItemJobInactiveQueue from '@/components/dashboard/ItemJobInactiveQueue';

export default {
	name: 'CardJobsInactiveQueue',
	components: { ItemJobInactiveQueue },
	data() {
		return {
			items: [],
		};
	},
	methods: {
		fetchData() {
			request({
				url: '/jobs/me/posted?status=EmptyQueue',
				method: 'get',
			}).then((response) => {
				this.items = response.data;
				this.cache = response.data;
			});
		},
	},
	computed: {
		cache: {
			get() {
				return this.$store.getters['cache/dashboardJobsInactiveQueue'];
			},
			set(items) {
				return this.$store.commit('cache/setCache', {
					name: 'dashboardJobsInactiveQueue',
					items
				});
			},
		}
	},
	created() {
		if ( this.cache ) {
			this.items = this.cache;
		}
		this.fetchData();
	},
}
</script>
